import moment from "moment";
import React, { Component } from "react";
import ItemCard, { ItemCardItem } from "./item-card";

// This function takes a component...
export function cardWithItems(WrappedComponent, items) {
  // ...and returns another component...
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        items,
        actions: {
          view: `/${props.slug}/${props.id}/view`,
          edit: `/${props.slug}/${props.id}/edit`,
          delete: `/${props.slug}/${props.id}/delete`
        }
      };
    }

    render() {
      // ... and renders the wrapped component with the fresh data!
      // Notice that we pass through any additional props
      const { object, slug, title, subheader, id } = this.props;
      const { actions, items } = this.state;

      return (
        <ItemCard
          actions={actions}
          avatar={title ? title.substr(0, 1) : ""}
          title={title}
          subheader={subheader}
          link={`/${slug}/` + id}
          isExpandable={this.props.isExpandable}>
          {items.map((item, index) => {
            let value = object[item.value];
            if (item.date) value = moment(value).format("DD.MM.YYYY");

            let itemCardItem = (
              <ItemCardItem
                key={index}
                title={item.title}
                value={value}
                full={item.full}
              />
            );

            if (!value) {
              itemCardItem = "";
            }

            return itemCardItem;
          })}
          <WrappedComponent {...this.props} />
        </ItemCard>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/library/card/Card.js